import React from 'react';
import { TestTube } from 'lucide-react';
import { StandardPageHeader } from '@/components/layout/StandardPageHeader';
import { AdminPageScaffold } from '@/components/core';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const TestLayout: React.FC = () => {
  return (
    <>
      <StandardPageHeader
        title="TEST LAYOUT PAGE"
        subtitle="Testing the layout pattern to debug width issues"
        icon={TestTube}
        actions={
          <Button>
            Test Action
          </Button>
        }
      />
      
      <AdminPageScaffold>
        {/* Simple test content to see if layout works */}
        <div className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Test Card 1</CardTitle>
            </CardHeader>
            <CardContent>
              <p>This is a test card to see if the layout fills the full width properly.</p>
              <p>If this page has empty space on the right, the issue is in the layout pattern itself.</p>
              <p>If this page works correctly, the issue is in the content components of the broken pages.</p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Test Card 2</CardTitle>
            </CardHeader>
            <CardContent>
              <p>Another test card with some content.</p>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
                <div className="bg-blue-100 p-4 rounded">Test Item 1</div>
                <div className="bg-green-100 p-4 rounded">Test Item 2</div>
                <div className="bg-purple-100 p-4 rounded">Test Item 3</div>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Full Width Test</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="w-full bg-gradient-to-r from-red-100 to-blue-100 p-8 rounded">
                <p className="text-center text-lg font-semibold">
                  This div should span the full available width
                </p>
                <p className="text-center text-sm mt-2">
                  If you see empty space on the right, we found the layout issue!
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Add a REALLY WIDE table to force width */}
          <Card>
            <CardHeader>
              <CardTitle>Wide Content Test - Data Table</CardTitle>
            </CardHeader>
            <CardContent className="overflow-x-auto">
              <table className="min-w-full">
                <thead>
                  <tr className="border-b">
                    <th className="text-left p-2">ID</th>
                    <th className="text-left p-2">Name</th>
                    <th className="text-left p-2">Email</th>
                    <th className="text-left p-2">Phone</th>
                    <th className="text-left p-2">Address</th>
                    <th className="text-left p-2">City</th>
                    <th className="text-left p-2">State</th>
                    <th className="text-left p-2">Status</th>
                    <th className="text-left p-2">Created</th>
                    <th className="text-left p-2">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {[1,2,3,4,5].map(i => (
                    <tr key={i} className="border-b">
                      <td className="p-2">{i}</td>
                      <td className="p-2 whitespace-nowrap">Test User {i}</td>
                      <td className="p-2 whitespace-nowrap">testuser{i}@example.com</td>
                      <td className="p-2 whitespace-nowrap">(555) 123-456{i}</td>
                      <td className="p-2 whitespace-nowrap">123 Long Street Name Ave</td>
                      <td className="p-2 whitespace-nowrap">New York</td>
                      <td className="p-2">NY</td>
                      <td className="p-2">Active</td>
                      <td className="p-2 whitespace-nowrap">2024-01-0{i}</td>
                      <td className="p-2">
                        <Button size="sm">Edit</Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardContent>
          </Card>
        </div>
      </AdminPageScaffold>
    </>
  );
};

export default TestLayout;